import React from 'react';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkGfm from "remark-gfm";


const MarkdownContent = ({ content }) => {
    return (
        <Box className='ai-message-markdown'>
            <ReactMarkdown
                children={content}
                remarkPlugins={[remarkGfm]}
                components={{
                    table: ({ node, ...props }) => (
                        <Table sx={{
                            width: 'auto',
                            my: 2,
                            border: '1px solid rgba(224, 224, 224, 1)',
                            borderRadius: '4px',
                            borderCollapse: 'separate',
                            overflow: 'hidden'
                        }} {...props} />
                    ),
                    thead: ({ node, ...props }) => (
                        <TableHead sx={{ backgroundColor: '#f5f5f5' }} {...props} />
                    ),
                    tbody: ({ node, ...props }) => (
                        <TableBody {...props} />
                    ),
                    tr: ({ node, ...props }) => (
                        <TableRow sx={{ '&:nth-of-type(odd)': { backgroundColor: 'rgba(0, 0, 0, 0.04)' } }} {...props} />
                    ),
                    th: ({ node, ...props }) => (
                        <TableCell
                            sx={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                borderBottom: '2px solid rgba(224, 224, 224, 1)',
                                padding: '12px 16px'
                            }}
                            {...props}
                        />
                    ),
                    td: ({ node, ...props }) => (
                        <TableCell
                            sx={{
                                fontSize: '14px',
                                padding: '10px 16px',
                                borderBottom: '1px solid rgba(224, 224, 224, 1)'
                            }}
                            {...props}
                        />
                    ),
                    h3: ({ children }) => {
                        return <h3 style={{ fontSize: '20px', fontWeight: 'bold' }}>{children}</h3>;
                    },
                    p: ({ children }) => {
                        return <p style={{ fontSize: '14px' }}>{children}</p>;
                    },
                    ul: ({ children }) => {
                        return <ul style={{ fontSize: '14px' }}>{children}</ul>;
                    },
                    ol: ({ children }) => {
                        return <ol style={{ fontSize: '14px' }}>{children}</ol>;
                    },
                    li: ({ children }) => {
                        return <li style={{ fontSize: '14px' }}>{children}</li>;
                    },
                }}
            />
        </Box>
    );
};

export default MarkdownContent;